import * as React from 'react';
import { useState } from 'react';
import Submission from './Submission';
import './TlxGroupVerdict.css';
import verdicts from './verdicts';

const SERVER_HOST = (process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_SERVER_HOST : process.env.REACT_APP_DEVELOPMENT_SERVER_HOST);

const TlxGroupVerdict = () => {
    const [submissions, setSubmissions] = useState<any>({
        data: []
    });
    const [username, setUsername] = useState('');
    const [verdict, setVerdict] = useState('ALL');

    const updateSubmissions = async event => {
        if(event.type === 'keypress' && event.key !== 'Enter'){
            return [];
        }
        const url = new URL(`/api/submissions/programming?username=${username}`, SERVER_HOST);
        const submissions = await fetch(url).then(response => response.json());
        setSubmissions(submissions);
    }

    return (
        <div className='group-verdict'>
            <div className='form'>
                <input className='username' placeholder='Username' onChange={event => setUsername(event.target.value)} onKeyPress={updateSubmissions}/>
                <button className='search' onClick={updateSubmissions}>Search</button>
            </div>
            <div className='submissions'>
                <label htmlFor="verdict">Verdict</label>
                <select id='verdict' onChange={event => setVerdict(event.target.value)}>
                    <option value='ALL'>ALL</option>
                    {Object.entries(verdicts).map(([key, value]) => <option key={key} value={key}>{value.alias}</option>)}
                </select>
                <table>
                    <tbody>
                        <tr>
                            <th>Problem</th>
                            <th>Verdict</th>
                            <th>Score</th>
                            <th>Submission</th>
                        </tr>
                        {submissions.data.filter(submission => verdict === 'ALL' || (verdict !== 'ALL' && submission.verdict === verdict)).map(submission => 
                            <Submission key={submission.id} submission={submission}/>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default TlxGroupVerdict;